import ProfileCardController from './profile-card-controller'

export default ProfileCardController
